import { createReference, isReadableReference } from "./mod.js";
/**
 * Converts a value or a readonly reference to a readonly reference for the
 * expected value. Ensures the result is always a readonly reference.
 *
 * @beta This is an experimental API and may change in future releases.
 */
export function ensureReference(value) {
    return isReadableReference(value)
        ? value
        : createReference(value).asReadonly();
}
